import React from 'react'
import { Link } from 'react-router-dom'

import './AboutSection.css'

function AboutSection({title, image, description, link, lastChild}) {
    return (
        <div className={`bg-light ${lastChild ? "largePaddingBottom" : "py-4"}`}>
            <div className="container">
                <div className="story">
                    <div className="row">
                        <div className="col-4 col-md-3 col-xl-2">
                            <figure className="story-shape">
                                <img 
                                    src={image} 
                                    alt="Story" 
                                    className="story-image" 
                                />
                                <figcaption className="story-caption">{title}</figcaption>
                            </figure>
                        </div>
                        <div className="col-8 col-md-9 col-xl-10">
                            <div className="story-text">
                                <h3 className="heading-tertiary">{title}</h3>
                                <p>
                                    {description}
                                </p>
                                <Link to={link}>Vis</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default AboutSection